<template>
  <div class="col border border-3">
    <span>
      {{ getPersonName({ personId: event.building_owner_id }) }} ({{
        getUsedMandateTantiemesChargeGenerale(event.mandate_id)
      }})
    </span>
    a donné son pouvoir
    <span v-if="event.move_from_representant_id != event.building_owner_id">
      de
      {{
        getPersonName({
          personId: event.move_from_representant_id,
          personType: event.move_from_representant_type,
        })
      }}
    </span>
    à
    <span>
      {{
        getPersonName({
          personId: event.move_to_representant_id,
          personType: event.move_to_representant_type,
        })
      }}.
    </span>
  </div>
</template>

<script>
export default {
  props: ["event"],
};
</script>
